export default class Nodes {

  public static isProject(type: NodeType) {
    return type === 'root'
  }

  public static isTopic(className: NodeClassName) {
    return className === 'Topic'
  }

  public static isTopicGroup(className: NodeClassName) {
    return className === 'TopicGroup'
  }

  public static isProjectStakeholder(className: NodeClassName) {
    return className === 'ProjectStakeholder'
  }

  public static isProjectStakeholderGroup(className: NodeClassName) {
    return className === 'ProjectStakeholderGroup'
  }

  public static isAction(className: NodeClassName) {
    return className === 'Action'
  }

  public static isActionGroup(className: NodeClassName) {
    return className === 'ActionGroup'
  }
}
